// Import files here. This is the main lib entry point.
// You can use ES5, or ES6 here.
import './mobile-menu';
import './scroll';
import './site';

jQuery.fn.extend({
    live: function(event, callback) {
        if (this.selector) {
            jQuery(document).on(event, this.selector, callback);
        }
    }
});

console.log('test');



// WEBPACK FOOTER //
// ./src/js/app/main.js